(ns com.theplantscape.plant-web.components.tailwind.forms.diagrams
  (:require
   [com.theplantscape.plant-web.components.forms.core
    :refer [update-atom-hm]]
   [com.theplantscape.plant-web.components.tailwind.buttons
    :refer [button-progress-async]]
   [com.theplantscape.web-ui.tailwind.ensemble :refer [form]]
   [com.theplantscape.web-ui.tailwind.form.elements.checkbox :as fc]
   [com.theplantscape.web-ui.tailwind.form.elements.input :as f]
   [reagent.core :as r]))

(defn ui-form-create-diagram [values cfg]
  (let [style "p-2 w-full "
        set-form-value (partial update-atom-hm values)]
    (fn [values cfg]
      [:div.w-full
       (str @values)
       [form
        {}
        [:<>
         [:div.grow
          [f/ui-form-input
           (r/cursor values [:values :diagram|title])
           {:name "diagram|title"
            :label "Title"
            :tooltip "Title"
            :input-classes (str style " w-full grow")
            :store-fn set-form-value}]]]]

       [fc/ui-form-boolean
        (r/cursor values [:values :diagram|public])
        {:name "diagram|public"
         :label "Available to the public"
         :store-fn set-form-value}]

       [f/ui-form-input
        (r/cursor values [:values :diagram|description])
        {:name "diagram|description"
         :label "Create Diagram"
         :store-fn set-form-value}]

       [:div.mt-4
        [button-progress-async
         "Create new diagram"
         {:on-click (fn [] ((:on-submit cfg) (:values @values)))
          :on-complete (:on-submit-complete cfg)}]]])))
